import AccessApartmentsChipList from './AccessApartmentsChipList';

export default AccessApartmentsChipList;
